import _, { select } from "underscore";
import Editor from "@/components/utils/Editor.vue";
import AddQuestionComponent from "../components/AddQuestionComponent.vue"
export default {
    name: "MaterialProjectAdd",
    components: {
        Editor,
        AddQuestionComponent
    },
    data() {
        let checkLink = (rule, value, callback) => {
            if (!/^(http:\/\/|https:\/\/).*/.test(value)) {
                callback(new Error('输入的链接格式不正确，请重新输入！'))
            } else {
                callback();
            }
        };
        return {
            headerObj: {
                'Authorization': localStorage.getItem('token'),
            },
            eDialogVisible: false,
            rDialogVisible: false,
            evaluate_form: {
                index: null,
                content: '',
                evaluate: '',
                score: ''
            },
            rules: {
                index: [
                    { required: true, message: '请输入评价序号', trigger: 'blur' },
                    { required: true, message: '请输入评价序号', trigger: 'change' },
                    { type: 'number', message: '序号必须为正整数', trigger: 'blur' },
                    { type: 'number', message: '序号必须为正整数', trigger: 'change' }
                ],
                content: [
                    { required: true, message: '请输入评价内容', trigger: 'blur' },
                    { required: true, message: '请输入评价内容', trigger: 'change' }
                ],
                evaluate: [
                    { required: true, message: '请输入评价要求', trigger: 'blur' },
                    { required: true, message: '请输入评价要求', trigger: 'change' }
                ],
                score: [
                    { required: true, message: '请输入评价分值', trigger: 'blur' },
                    { type: 'number', message: '评分分值必须为正整数', trigger: 'blur' }
                ]
            },
            link_form: {
                name: '',
                url: ''
            },
            link_rules: {
                name: [
                    { required: true, message: '请输入链接名称', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在2-10个字符', trigger: 'blur' }
                ],
                link: [
                    { required: true, message: '请输入链接网址', trigger: 'blur' },
                    { validator: checkLink, trigger: 'blur' }
                ]
            },
            // 0=无,2=账号数据分析,3=数据全景分析,4=作品数据分析,5=粉丝数据分析,6=经营分析,7=内容分析,8=粉丝分析,9=变现分析,10=综合概览分析,11=场景运营数据分析,12=粉丝群数据分析,13=经营数据分析,14=用户数据分析,15=个人Dou+投放案例分析,16=企业Dou+投放案例分析,17=高播放量短视频案例分析,18=高点赞量短视频案例分析,19=高评论量短视频案例分析,20=高分享量短视频案例分析,21=知识型短视频数据分析,22=技能型短视频数据分析,23=娱乐型短视频数据分析,24=共鸣型短视频数据分析,25=三农带货短视频案例分析,26=日用品带货短视频案例分析,27=电子类带货短视频案例分析
            training_data_list: [
                // { label: "热门视频", value: 1 }
                { label: "账号数据分析", value: 2 },
                { label: "数据全景分析", value: 3 },
                { label: "作品数据分析", value: 4 },
                { label: "粉丝数据分析", value: 5 },
                { label: "经营分析", value: 6 },
                { label: "内容分析", value: 7 },
                { label: "粉丝分析", value: 8 },
                { label: "变现分析", value: 9 },
                { label: "综合概览分析", value: 10 },
                { label: "场景运营数据分析", value: 11 },
                { label: "粉丝群数据分析", value: 12 },
                { label: "经营数据分析", value: 13 },
                { label: "用户数据分析", value: 14 },
                { label: "个人Dou+投放案例分析", value: 15 },
                { label: "企业Dou+投放案例分析", value: 16 },
                { label: "高播放量短视频案例分析", value: 17 },
                { label: "高点赞量短视频案例分析", value: 18 },
                { label: "高评论量短视频案例分析", value: 19 },
                { label: "高分享量短视频案例分析", value: 20 },
                { label: "知识型短视频数据分析", value: 21 },
                { label: "技能型短视频数据分析", value: 22 },
                { label: "娱乐型短视频数据分析", value: 23 },
                { label: "共鸣型短视频数据分析", value: 24 },
                { label: "三农带货短视频案例分析", value: 25 },
                { label: "日用品带货短视频案例分析", value: 26 },
                { label: "电子类带货短视频案例分析", value: 27 },
            ],
            form: {
                project_title: '',
                resource_class_id: [],
                project_duration: null,
                project_difficulty: null,
                project_attrs: [{
                    name: '项目简介',
                    value: ''
                },
                {
                    name: '项目目标',
                    value: ''
                },
                {
                    name: '项目要求',
                    value: ''
                },
                {
                    name: '待定栏目一',
                    value: ''
                },
                {
                    name: '待定栏目二',
                    value: ''
                }
                ],
                project_task: {
                    name: '项目任务',
                    value: ''
                },
                answer_analysis: {
                    name: '答案解析',
                    value: ''
                },
                project_evaluate: [],
                project_knowledge_link: [],
                project_sucai: [],
                project_apps_id: [],
                project_ability: '',
                training_data_type: undefined,
                topic_data: []
            },
            formRules: {
                topic_title: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                    { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                ], score: [{ required: true, message: '请输入分值', trigger: 'blur' },]
            },
            options: [],
            addQuestionsDrawer: false,
            selectObj: {},
            topic_ids: [],
            class_props: {
                label: 'rc_name',
                value: 'rc_id'
            },
            quillOptions: {
                placeholder: "请输入项目任务"
            },
            fileList: [],
            material_list: [],
            material_type: null,
            course_list: [],
            course_id: [],
            resource_list: [],
            resource_id: null,
            dialog_status: null,
            preview_src: null,
            video_src: null,
            evaluate_form_index: null,
            course_attr: {
                label: 'name',
                value: 'id'
            },
            app_lists: [],
            application_status: false,
            app_tmp_array: [],
            apps_selected: [],
            edit_key: null,
            edit_Answerkey: null,
            id: null,
            allScore:0

        }
    },
    created() {
        this.projectClasses();
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
            this.formEditStatus();
        }
    },
    computed: {
        isAppOrLink() {
            if (this.material_type === null) {
                return false;
            }
            else return [6, 7].indexOf(Number(this.material_type)) !== -1;
        }
    },
    methods: {
        updateTask(val) {
            this.form.project_task.value = val
        },
        updateAnswer(val) {
            this.form.answer_analysis.value = val
        },
        goBack() {
            this.$router.go(-1);
        },
        checkPjTitle() {
            let param = {
                project_title: this.form.project_title
            }
            if (this.id) {
                param.id = this.id;
            }
            return new Promise((resolve, reject) => {
                this.$http.axiosGetBy(this.$api.checkProjectName, param, (res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                })
            })

        },
        formEditStatus() {
            this.$http.axiosGetBy(this.$api.getProjectDetail, { id: this.id }, (res) => {
                if (res.code === 200) {
                    if (!res.data.answer_analysis || (res.data.answer_analysis.length === 0)) {
                        res.data.answer_analysis = {
                            name: "答案解析",
                            value: ""
                        }
                    }
                    this.form = res.data;
                    if (this.form.project_sucai.length > 0) {
                        this.form.project_sucai.map((item) => {
                            let file_item = {
                                name: item.file_name,
                                url: item.file_path
                            }
                            this.fileList.push(file_item);
                        });
                    }
                    if (this.form.app_lists.length > 0) {
                        this.form.app_lists.map((item) => {
                            let app = {
                                app_name: item.app_name,
                                logo: {
                                    src: item.logo
                                },
                                home_link: item.home_link,
                                shop_link: item.shop_link,
                                teacher_link: item.teacher_link
                            }
                            this.apps_selected.push(app);
                        });
                    }

                    // 如果实训数据为0则无实训数据
                    if (this.form.training_data_type === 0) {
                        this.form.training_data_type = undefined;
                    }
                }
            }, (err) => {
                this.$common.axiosErrorMsg(err);
            });

        },
        editAct(key) {
            this.edit_key = key;
        },
        editDone() {
            this.edit_key = null;
        },
        editAnswerAct(key) {
            this.edit_Answerkey = key;
        },
        editAnswerDone() {
            this.edit_Answerkey = null;
        },
        submitEform(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let evaluate_obj = Object.assign({}, this.evaluate_form);
                    if (this.evaluate_form_index !== null) {
                        this.$set(this.form.project_evaluate, this.evaluate_form_index, evaluate_obj);
                        this.evaluate_form_index = null;
                    } else {
                        this.form.project_evaluate.push(evaluate_obj);
                    }
                    this.$refs[formName].resetFields();
                    this.eDialogVisible = false;
                } else {
                    return false;
                }
            })
        },
        editEvaluete(index, row) {
            row = { ...row, index: Number(row.index), score: Number(row.score) };
            this.evaluate_form = { ...row };
            this.evaluate_form_index = index;
            this.eDialogVisible = true;
        },
        deleteEvaluete(index, row) {
            this.$confirm('此操作将永久删除该评价，是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.form.project_evaluate.splice(index, 1);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        handleRemove(file, fileList) {
            this.fileList = _.filter(fileList, (item) => {
                return item.uid !== file.uid;
            })
        },
        courseList() {
            this.$http.axiosGet(this.$api.getCourseList, (res) => {
                if (res.code === 200) {
                    let array = [];
                    if (res.data.length > 0) {
                        res.data.map((item) => {
                            let value = {
                                id: item.course_id,
                                name: item.course_name
                            };
                            if (item.course_content && item.course_content.length > 0) {
                                value.children = [];
                                item.course_content.map((_it, _i) => {
                                    let _chapter = {
                                        id: _i,
                                        name: _it.name
                                    }
                                    if (_it.children && _it.children.length > 0) {
                                        _chapter.children = [];
                                        _it.children.map((_node, _node_index) => {
                                            let node_item = {
                                                id: { index: _node_index, value: _node.children },
                                                name: _node.name
                                            };
                                            _chapter.children.push(node_item);
                                        });

                                    }
                                    value.children.push(_chapter);
                                });
                            }
                            array.push(value);
                        });
                    }
                    this.course_list = array;
                }
            }, (err) => {
                this.$common.axiosErrorMsg(err);
            })
        },
        /*beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },*/
        beforeMUpload(file) {
            let tmp = file.name.split('.');
            let extension = tmp[tmp.length - 1];
            let ext_allowed = 'mp4,avi,pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,png,zip,rar';
            let ext_allowed_arr = ext_allowed.split(',');
            if (ext_allowed_arr.indexOf(extension) === -1) {
                this.$message({
                    type: 'error',
                    message: '上传文件类型不支持',
                    duration: 1000,
                });
                return false;
            }
        },
        handleSuccess(res, file) {
            if (res.code === 200) {
                this.fileList.push(file);
            } else {
                this.$message({
                    type: 'warning',
                    message: res.msg,
                    duration: 1000,
                    onClose: () => {
                        this.handleRemove(file, this.fileList);
                    }
                });
            }
        },
        initResourceDialog() {
            this.assortMaterialList();
            this.courseList();
        },
        assortMaterialList() {
            this.$http.axiosGet(this.$api.getMatingTypeList, (res) => {
                if (res.code === 200) {
                    this.material_list = res.list;
                }
            }, (err) => {
                this.$common.axiosErrorMsg(err)
            })
        },
        formatList(list) {
            let array = [];
            for (let i = 0; i < list.length; i++) {
                let item = list[i];
                if (item.children && item.children.length > 0) {
                    let value = {
                        rc_id: item.rc_id,
                        rc_name: item.rc_name,
                        children: this.formatList(item.children)
                    }
                    array.push(value);
                } else {
                    let value = {};
                    value.rc_id = item.rc_id;
                    value.rc_name = item.rc_name;
                    array.push(value);
                }
            }
            return array;
        },
        projectClasses() {
            this.$http.axiosGetBy(this.$api.resourceClassList, { type: 4 }, (res) => {
                if (res.code === 200) {
                    let list = this.formatList(res.list);
                    this.options = list;
                } else {
                    this.$message.warning(res.msg);
                }
            }, (err) => {
                this.$common.axiosErrorMsg(err);
            });
        },
        projectClassesHandler(value) {
            // console.log(value);
        },
        addAppDialog() {
            this.rDialogVisible = true;
            this.material_type = 6;
            this.application_status = true;
            this.app_tmp_array = this.form.project_apps_id;
            this.applicationsList();
        },
        addKnowledgeLink() {
            this.rDialogVisible = true;
        },
        handleChangeCourse(val) {
            let tmp_val = val[val.length - 1];
            let course_id = val[0];
            let course_chapter = val[1];
            let course_node = tmp_val.index;
            let course_arr = [];
            if (tmp_val.value.length > 0) {
                tmp_val.value.map((item) => {
                    let val = {
                        material_type_id: this.material_type,
                        type: item.type,
                        id: Number(item.id)
                    };
                    course_arr.push(val);
                });
            }
            let param = {
                course_arr,
                material_type_id: this.material_type,
                course_id,
                course_node,
                course_chapter
            }
            this.$http.axiosPost(this.$api.getResource, param, (res) => {
                if (res.code === 200) {
                    this.resource_list = res.data;
                }
            }, (err) => {
                this.$common.axiosErrorMsg(err)
            })
        },
        handleMaterialType(val) {
            this.material_type = val;
            if (this.isAppOrLink) {
                if (Number(this.material_type) === 6) {
                    this.applicationsList();
                }
                this.preview_src = null;
                this.video_src = null;
            }
        },
        handleChangeResource(val) {
            let resource_item = _.find(this.resource_list, { resource_id: val });
            let file_arr = resource_item.file_name.split('.');
            let ext = file_arr[file_arr.length - 1];
            if (ext.toLowerCase() === 'mp4') {
                this.video_src = resource_item.file_preview_path;
                this.preview_src = null;
            } else {
                this.preview_src = resource_item.file_preview_path;
                this.video_src = null;
            }
        },
        resetResourceDialog() {
            this.preview_src = null;
            this.video_src = null
            this.material_type = null;
            this.resource_id = null;
            this.course_id = [];
            this.course_list = [];
            this.application_status = false;
        },
        applicationsList() {
            this.$http.axiosGetBy(this.$api.app_showApp, { type: 'all', parent_id: 0 }, (res) => {
                if (res.code === 200) {
                    this.app_lists = res.data;
                } else {
                    this.$message.warning(res.msg);
                }
            }, (err) => {
                this.$common.axiosErrorMsg(err);
            })
        },
        appIdsSelected(id) {
            if (this.app_tmp_array.indexOf(id) !== -1) {
                this.app_tmp_array = _.filter(this.app_tmp_array, (item) => {
                    return Number(item) !== Number(id);
                })
            } else {
                this.app_tmp_array.push(id);
            }
        },
        appIdhasSelected(id) {
            if (this.app_tmp_array.indexOf(id) !== -1) {
                return 'selected';
            } else {
                return '';
            }
        },
        rFormSubmit() {
            switch (this.material_type) {
                case 6:
                    //设置应用
                    this.form.project_apps_id = [].concat(this.app_tmp_array);
                    this.apps_selected = _.filter(this.app_lists, (item) => {
                        if (this.form.project_apps_id.indexOf(item.id) !== -1) {
                            return item;
                        }
                    });
                    this.app_tmp_array = [];
                    this.rDialogVisible = false;
                    break;
                case 7:
                    //设置链接
                    this.$refs['link_form'].validate((valid) => {
                        if (valid) {
                            let form_value = Object.assign({}, this.link_form);
                            form_value.type = 7;
                            this.form.project_knowledge_link.push(form_value);
                            this.$refs['link_form'].resetFields();
                            this.rDialogVisible = false;
                        }
                    })
                    break;
                default:
                    //默认设置配套材料
                    let link_form = {
                        id: this.resource_id,
                        type: this.material_type
                    };
                    let link_item = _.find(this.resource_list, { resource_id: link_form.id })
                    link_form.name = link_item.file_name;
                    link_form.url = link_item.file_preview_path;
                    this.form.project_knowledge_link.push(link_form);
                    this.rDialogVisible = false;
                    break;
            }
        },
        typeClass(name, type) {
            if (Number(type) === 7) {
                return 'animation-link';
            }
            let tmp_array = name.split(".");
            let ext = tmp_array[tmp_array.length - 1];
            let classname = '';
            switch (ext) {
                case 'docx':
                    classname = 'textbook';
                    break;
                case 'ppt':
                    classname = 'coureware';
                    break;
                case 'mp4':
                    classname = 'micro-lesson';
                    break;
                case 'pdf':
                    classname = 'person-resource';
                    break;
                default:
                    break;
            }
            return classname;
        },
        removeLink(key) {
            this.form.project_knowledge_link.splice(key, 1);
        },
        removeApp(key) {
            let item = this.apps_selected[key];
            this.form.project_apps_id = _.filter(this.form.project_apps_id, (_it) => {
                return _it !== item.id;
            });
            this.apps_selected.splice(key, 1);
        },
        async saveProject() {

            try {
                if (this.form.project_title.length === 0) {
                    throw new Error('请输入项目标题');
                }
                if (this.form.project_title.length > 24) {
                    throw new Error('项目标题长度不能超过24个字符');
                }
                if (this.form.resource_class_id.length === 0) {
                    throw new Error('项目分类必选');
                }
                if (!this.form.project_duration) {
                    throw new Error('项目课时必填');
                }
                if (!this.form.project_difficulty) {
                    throw new Error('项目难度必填');
                }
                if (this.form.project_task.value.length === 0) {
                    throw new Error('项目任务必填');
                }
                if (/<p>(&nbsp;|&nbsp;|<br>)+<\/p>/.test(this.form.project_task.value)) {
                    throw new Error('项目任务不能为空');
                }
                if (this.form.topic_data.length == 0) {
                    throw new Error('题目不能为空');
                }
                const res = await this.checkPjTitle();
                if (res.code === 400) {
                    throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.warning(error.message);
                return;
            }
            const result = this.validateData(this.form.topic_data);
            if(!result.valid) return
            if (result.score !== 100) {
                this.$message.error('所有题目的总分值必须为 100 分');
                return;
            }
            // if (result.valid) {
            //     this.$message.success('表单验证通过，可以保存数据');
            //     // 这里可以添加保存数据的逻辑
            // }
            this.form.project_sucai = [];
            if (this.fileList.length > 0) {
                this.fileList.map((_item) => {
                    let value = {};
                    if (_item.response) {
                        value.file_name = _item.response.data.name;
                        value.file_path = _item.response.data.path;
                    } else {
                        value.file_name = _item.name;
                        value.file_path = _item.url;
                    }
                    this.form.project_sucai.push(value);
                });
            }
            if (this.id) {
                this.form.id = this.id;
            }
            let form = JSON.parse(JSON.stringify(this.form));

            if (this.form.project_knowledge_link.length > 0) {
                let knowledge_links = [];
                this.form.project_knowledge_link.map((_val) => {
                    let tmp = {};
                    if (Number(_val.type) === 7) {
                        tmp.type = _val.type;
                        tmp.url = _val.url;
                        tmp.name = _val.name;
                    } else {
                        tmp.id = _val.id;
                        tmp.type = _val.type;
                    }
                    knowledge_links.push(tmp);
                });
                form.project_knowledge_link = knowledge_links;
            }
            form.resource_class_id = form.resource_class_id[form.resource_class_id.length - 1];

            if (!form.training_data_type) form.training_data_type = 0;

            // 答案解析判断
            if (
                /<p>(&nbsp;|&nbsp;|<br>)+<\/p>/.test(form.answer_analysis.value) ||
                !form.answer_analysis ||
                form.answer_analysis.length === 0
            ) {
                form.answer_analysis = [];
            }

            this.$http.axiosPost(this.$api.saveProject, form, (res) => {
                if (res.code === 200) {
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 1000,
                        onClose: () => {
                            this.$router.push({ path: '/admin/index', query: { name: "project" } });
                        }
                    });
                }
            }, (error) => {
                this.$common.axiosErrorMsg(error);
            });
        },
        validateData(data) {
            let totalScore = 0;
            for (let item of data) {
                if (item.type === 1 || item.type === 3) {
                    if (!item.class_name) {
                        this.$message.error('请输入名称');
                        return { valid: false, score: 0 };
                    }
                    if (item.children && item.children.length === 0) {
                        this.$message.error('每个名称下至少需要添加一道题目');
                        return { valid: false, score: 0 };
                    }
                }
                if (item.type === 2 || item.type === 4) {
                    if (item.score === null || item.score === undefined || isNaN(item.score)) {
                        this.$message.error('请输入有效的分值');
                        return { valid: false, score: 0 };
                    }
                    totalScore += parseFloat(item.score);
                }
                if (item.children) {
                    const childResult = this.validateData(item.children);
                    if (!childResult.valid) {
                        return { valid: false, score: 0 };
                    }
                    totalScore += childResult.score;
                }
            }
            return { valid: true, score: totalScore };
        },
        getRowStyle({ row, rowIndex }) {
            //  if (Number(row.type) == 4) {
            //     return {
            //         background: '#f5f9ff'
            //     };
            // }

        },
        addTestName() { //添加一级
            let obj = {
                id: this.generate6DigitId(),
                class_name: "",
                type: 1,
                children: []
            }
            this.form.topic_data.push(obj)
        },
        addSecondClass_name(row) { //添加二级
            let obj = {
                id: this.generate6DigitId(),
                class_name: "",
                type: 3,
                children: []
            }
            row.children.push(obj)
        },
        addTopic(row) {
            // 添加题目
            this.topic_ids = []
            this.addQuestionsDrawer = true
            // this.form.topic_data.forEach(item=>{
            //     item.children?.forEach(data=>{
            //         if(data.hasOwnProperty('topic_id')){
            //             this.topic_ids.push(Number(data.topic_id)) 
            //         }else{
            //             data.children?.forEach(data2=>{
            //                 this.topic_ids.push(Number(data2.topic_id)) 
            //             })
            //         }
            //     })
            // })
            // console.log(row);
            if (Number(row.type == 1)) {
                //添加一级题目
                row.children.forEach(item => {
                    if (Number(item.type) == 2) {
                        this.topic_ids.push(Number(item.topic_id))
                    }
                })
            }
            if (Number(row.type == 3)) {
                //添加二级题目
                row.children.forEach(item => {
                    if (Number(item.type) == 4) {
                        this.topic_ids.push(Number(item.topic_id))
                    }
                })
            }


            // console.log(this.topic_ids, "this.topic_ids");




            this.selectObj = row
        },
        handleQuestionsDrawerClose() {
            this.addQuestionsDrawer = false
        },
        confirmAddQuestion() {
            this.$refs.AddQuestionComponentRef.changeStep()
        },
        putInPaper(val, ids) {
            // console.log(val, ids, "ppppppppppp");

            // 先判断是否被删除掉了
            // this.form.topic_data.forEach(item=>{
            //     item.children?.forEach((data,index)=>{
            //         if(data.hasOwnProperty('topic_id')){
            //             if(!ids.includes(Number(data.topic_id))){
            //                 item.children.splice(index,1)
            //             }
            //         }else{
            //             data.children?.forEach((data2,index2)=>{
            //                 if(!ids.includes(Number(data2.topic_id))){
            //                     item.children.splice(index2,1)
            //                 }
            //             })
            //         }
            //     })
            // })
            if (Number(this.selectObj.type) == 1) {
                // 对一级题目进行操作的
                this.form.topic_data.forEach(item => {
                    if (item.id == this.selectObj.id) {
                        item.children?.forEach((data, index) => {
                            if (data.hasOwnProperty('topic_id')) {
                                if (!ids.includes(Number(data.topic_id))) {
                                    item.children.splice(index, 1)
                                }
                            }
                        })
                    }

                })
            }
            if (Number(this.selectObj.type) == 3) {
                this.form.topic_data.forEach(item => {
                    item.children?.forEach(data => {
                        if (!data.hasOwnProperty('topic_id')) {
                            if (data.id == this.selectObj.id) {
                                data.children?.forEach((data2, index2) => {
                                    if (!ids.includes(Number(data2.topic_id))) {
                                        item.children.splice(index2, 1)
                                    }
                                })
                            }
                        }
                    })
                })
            }
            // console.log(  this.form.topic_data,"  this.form.topic_data");

            if (val.length != 0) {
                val.forEach(item => {
                    let obj = {
                        id: this.generate6DigitId(),
                        score: void 0,
                        type: Number(this.selectObj.type) + 1,
                        ...item
                    }
                    this.form.topic_data.forEach((item) => {
                        if (item.id == this.selectObj.id) {
                            item.children.push(obj)
                        } else {
                            if (item.children.length > 0) {
                                item.children.forEach(data => {
                                    if (data.id == this.selectObj.id) {
                                        data.children.push(obj)
                                    }
                                })
                            }
                        }
                    })

                });
            }

            this.addQuestionsDrawer = false
            this.$refs.questionTableRef.toggleRowExpansion(this.selectObj, true)

        },
        deleteTopic(row) {
            this.form.topic_data = this.removeElementById(this.form.topic_data, row.id)
            if(Number(row.type)==2 || Number(row.type)==4){
                if(row.score){
                    this.getScore()
                }
            }
        },
        removeElementById(arr, targetId) {
            return arr.filter(item => {
                if (item.id === targetId) {
                    return false; // 如果当前元素的 id 等于目标 id，则过滤掉该元素
                }
                if (item.children && item.children.length > 0) {
                    // 如果当前元素有子元素，递归调用 removeElementById 函数处理子元素
                    item.children = this.removeElementById(item.children, targetId);
                }
                return true; // 保留当前元素
            });
        },
        cancelQuestion() {
            this.addQuestionsDrawer = false
        },
        goUp(row) {
            let obj = { ...row }
            if (row.type == 1) {
                // 一级名称移动

                let index = this.form.topic_data.findIndex(item => item.id == row.id)
                this.$set(this.form.topic_data, index, this.form.topic_data[index - 1]);
                this.$set(this.form.topic_data, index - 1, obj);
            } else if (row.type == 4) {
                for (let item of this.form.topic_data) {
                    for (let [index, data] of item.children.entries()) {
                        if (data.children) {
                            for (let [subIndex, subItem] of data.children.entries()) {
                                if (subItem.id === row.id) {
                                    this.$set( data.children, subIndex,  data.children[subIndex - 1]);
                                    this.$set( data.children, subIndex - 1, obj);
                                    return
                                }
                            }
                        }
                    }
                }
            } else {
                for (let item of this.form.topic_data) {
                    for (let [index, data] of item.children.entries()) {
                        if (data.id === row.id) {
                            this.$set(item.children, index, item.children[index - 1]);
                            this.$set(item.children, index - 1, obj);
                            return 
                        }
                    }
                }
            }

        },
        goDown(row) {
            let obj = { ...row }
            if (row.type == 1) {
                // 一级名称移动
                let index = this.form.topic_data.findIndex(item => item.id == row.id)
                this.$set(this.form.topic_data, index, this.form.topic_data[index + 1]);
                this.$set(this.form.topic_data, index + 1, obj);
            } else if (row.type == 4) {
                for (let item of this.form.topic_data) {
                    for (let [index, data] of item.children.entries()) {
                        if (data.children) {
                            for (let [subIndex, subItem] of data.children.entries()) {
                                if (subItem.id === row.id) {
                                    this.$set( data.children, subIndex,  data.children[subIndex + 1]);
                                    this.$set( data.children, subIndex + 1, obj);
                                    return
                                }
                            }
                        }
                    }
                }
            } else {
                for (let item of this.form.topic_data) {
                    for (let [index, data] of item.children.entries()) {
                        if (data.id === row.id) {
                            this.$set(item.children, index, item.children[index + 1]);
                            this.$set(item.children, index + 1, obj);
                            return 
                        }
                    }
                }
            }
        },
        isShow(row, type) {
            if (type == 1) {
                // 判断是不是第一个
                if (row.type == 1) {
                    // 一级内判断
                    let index = this.form.topic_data.findIndex(item => item.id == row.id)
                    if (index == 0) {
                        return false
                    } else {
                        return true
                    }
                } else if (row.type == 4) {
                    for (let item of this.form.topic_data) {
                        for (let [index, data] of item.children.entries()) {
                            if (data.children) {
                                for (let [subIndex, subItem] of data.children.entries()) {
                                    if (subItem.id === row.id) {
                                        return subIndex !== 0;
                                    }
                                }
                            }
                        }
                    }
                    return false;

                } else {
                    for (let item of this.form.topic_data) {
                        for (let [index, data] of item.children.entries()) {
                            if (data.id === row.id) {
                                return index !== 0;
                            }
                        }
                    }
                    return false;
                }

            } else {
                // 判断是不是最后一个
                if (row.type == 1) {
                    // 一级内判断
                    let index = this.form.topic_data.findIndex(item => item.id == row.id)
                    if (index == this.form.topic_data.length - 1) {
                        return false
                    } else {
                        return true
                    }
                } else if (row.type == 4) {
                    for (let item of this.form.topic_data) {
                        for (let [index, data] of item.children.entries()) {
                            if (data.children) {
                                for (let [subIndex, subItem] of data.children.entries()) {
                                    if (subItem.id === row.id) {
                                        return subIndex !== data.children.length - 1;
                                    }
                                }
                            }
                        }
                    }
                    return false;
                } else {
                    for (let item of this.form.topic_data) {
                        for (let [index, data] of item.children.entries()) {
                            if (data.id === row.id) {
                                return index !== item.children.length - 1;
                            }
                        }
                    }
                    return false;
                }
            }

        },


        generate6DigitId() {
            const timestamp = Date.now().toString();
            const random = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
            const id = (parseInt(timestamp + random) % 900000 + 100000).toString();
            return id;
        },
        getScore(){
            this.allScore=0
            this.calculateScore(this.form.topic_data);
        },
        calculateScore(items) {
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if ((item.type === 2 || item.type === 4) && item.score) {
                    this.allScore += item.score;
                }
                if (item.children && item.children.length > 0) {
                    this.calculateScore(item.children);
                }
            }
        }
    },
}
